import React from 'react';
import HeroSection from '../../components/shared/HeroSection';
import Introduction from './sections/Introduction';
import OurApproach from './sections/OurApproach';
import SafetyLifecycle from './sections/SafetyLifecycle';
import GlobalProjects from './sections/GlobalProjects';
import CoreValues from './sections/CoreValues';
import Footer from '../../components/shared/Footer';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <HeroSection 
        backgroundImage="/assets/asset-1.webp"
        title="About Us"
      />

      {/* Introduction */}
      <Introduction />

      {/* Our Approach */}
      <OurApproach />

      {/* Safety Lifecycle Expertise */}
      <SafetyLifecycle />

      {/* Global Project Experience */}
      <GlobalProjects />

      {/* Core Values */}
      <CoreValues />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;